import React from 'react';
import { makeStyles } from 'design-system/styles';

const useStyles = makeStyles({
  table: {
    width: '100%',
    textAlign: 'left',
  },
  headerRow: {
    padding: '10px 0',
    '& th': {
      paddingTop: '10px',
      paddingBottom: '10px',
      paddingRight: '5px',
    },
  },
  dataCell: {
    borderTop: '1px solid #e6e6e6',
    '&:not(:last-child)': {
      paddingRight: '5px',
    },
    '&:not(:empty)': {
      minWidth: '30px',
    },
  },
});

const QMTable: React.FC<{ children?: React.ReactNode }> = props => {
  const classes = useStyles();
  return (
    <div>
      <table className={classes.table}>{props.children}</table>
    </div>
  );
};

export const QMHeaderRow: React.FC<{ children?: React.ReactNode }> = props => {
  const classes = useStyles();
  return (
    <thead className={classes.headerRow}>
      <tr>{props.children}</tr>
    </thead>
  );
};

export const QMDataRow: React.FC<{ children?: React.ReactNode }> = props => {
  return (
    <tbody>
      <tr>{props.children}</tr>
    </tbody>
  );
};

export const QMDataCell: React.FC<{ children?: React.ReactNode }> = props => {
  const classes = useStyles();
  return <td className={classes.dataCell}>{props.children}</td>;
};

export default QMTable;
